import { ofType } from "redux-observable";
import { delay, mapTo, take } from "rxjs/operators";
import { TypeActionNetwork } from "../../../network/actionNetwork";
import { actionGameTrackingUpdateClientFunnel } from "../../actionGameTracking";
import { IdGameTrackingClientFunnelState } from "../IdGameTrackingClientFunnelState";
export var epicGameTrackingClientFunnelConnectEnd = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionNetwork.Connected), take(1), delay(1), mapTo(actionGameTrackingUpdateClientFunnel(IdGameTrackingClientFunnelState.SERVER_CONNECTION_END)));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/game-tracking/game-funnel/epics/epicGameTrackingClientFunnelConnectEnd.ts
// module id = 1870
// module chunks = 3